import { initializeApp } from 'firebase/app'
import { getMessaging } from 'firebase/messaging'
import { getAnalytics } from 'firebase/analytics'


const firebaseConfig = {
    apiKey: 'AIzaSyCZ2Wkqhv6lRK0d7a4wrdRi7PlXWac7-5M',
    authDomain: 'eros-universe-8cddf.firebaseapp.com',
    projectId: 'eros-universe-8cddf',
    storageBucket: 'eros-universe-8cddf.firebasestorage.app',
    messagingSenderId: '321359135622',
    appId: '1:321359135622:web:af30838c4266261043e207',
    measurementId: 'G-M2F32Z77PK'
}

const app = initializeApp(firebaseConfig)
const messagingApp = getMessaging(app)

const getAnalyticsConsent = () => {
    try {
        const match = document.cookie.split(';').map(c => c.trim()).find(c => c.startsWith('cookie_consent='))
        if (!match) return false
        const prefs = JSON.parse(decodeURIComponent(match.split('=').slice(1).join('=')))
        return prefs?.analytics_performance === true
    } catch {
        return false
    }
}

export let analytics = getAnalyticsConsent() ? getAnalytics(app) : null

export const applyAnalyticsConsent = (enabled) => {
    analytics = enabled ? (analytics || getAnalytics(app)) : null
}

export const initAnalytics = () => applyAnalyticsConsent(true)

export { messagingApp }
